import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RequestStatus } from '../../enums/request-status.enum';
import { ELinksState } from './e-links.reducer';

export const selectELinksState = createFeatureSelector<ELinksState>('eLinks');

export const selectELinks = createSelector(selectELinksState, (state) => state.eLinks);

export const selectELinksMeta = createSelector(selectELinksState, (state) => state.meta);

export const selectELinksLoading = createSelector(
  selectELinksState,
  (state) => state.listStatus === RequestStatus.Loading
);

export const selectELinkDeleting = createSelector(
  selectELinksState,
  (state) => state.deleteStatus === RequestStatus.Loading
);

export const selectELinksError = createSelector(selectELinksState, (state) => state.error);

export const selectELinksLastQuery = createSelector(
  selectELinksState,
  (state) => state.lastQuery
);

/* -------------------------------------------------------------------------- */
/* Editor selectors                                                            */
/* -------------------------------------------------------------------------- */

export const selectCurrentELink = createSelector(
  selectELinksState,
  (state) => state.currentELink
);

export const selectELinkOptions = createSelector(
  selectELinksState,
  (state) => state.options
);

export const selectELinkLoading = createSelector(
  selectELinksState,
  (state) => state.detailStatus === RequestStatus.Loading
);

export const selectELinkOptionsLoading = createSelector(
  selectELinksState,
  (state) => state.optionsStatus === RequestStatus.Loading
);

export const selectELinkSaving = createSelector(
  selectELinksState,
  (state) => state.saveStatus === RequestStatus.Loading
);

export const selectELinkSaveError = createSelector(
  selectELinksState,
  (state) => state.saveError
);

export const selectELinkSaveFieldErrors = createSelector(
  selectELinksState,
  (state) => state.saveFieldErrors
);
